module.exports = __webpack_public_path__ + "img/historyLinkImg.1da7ff0f.png";